import * as rd from '@devexperts/remote-data-ts'
import { BookingPeriod } from '@spiaggeit/spit-datepicker'
import { generatePath } from 'react-router-dom'
import { CHOOSE_PRODUCT_PATH, TICKETS_PATH } from '@/app/router/paths'
import { License, LicenseBookingCartMode } from '@/models/license'
import { GroupIds } from '@/models/service'
import {
  BookingAvailability,
  bookingAvailabilitySlice,
} from '@/store/bookingAvailabilitySlice'
import { getSpotsPageByBookingMode } from '@/utils/getSpotsPageByBookingMode'

export const getNextPathAfterChoosingPeriod = (payload: {
  bookingAvailability: ReturnType<
    typeof bookingAvailabilitySlice.selectors.self
  >
  bookingPeriod: BookingPeriod | null
  groupIds: GroupIds
  license: License
}): string | null => {
  if (!payload.license) {
    return null
  }
  const chooseProductPath = generatePath(CHOOSE_PRODUCT_PATH, {
    license: payload.license?.license,
  })
  const ticketsPath = generatePath(TICKETS_PATH, {
    license: payload.license.license,
  })
  const spotsPage = getSpotsPageByBookingMode(payload.license.bookingMode)
  const spotsPath = generatePath(spotsPage, {
    license: payload.license.license,
  })
  const hasTicketsGroupIdsFilter =
    payload.groupIds !== null && payload.groupIds.length > 0

  if (!rd.isSuccess(payload.bookingAvailability)) {
    return null
  }

  if (payload.license?.bookingCartMode === LicenseBookingCartMode.V_2022) {
    return spotsPath
  }

  if (payload.bookingAvailability.value.type === BookingAvailability.SPOTS) {
    return spotsPath
  }

  if (payload.bookingAvailability.value.type === BookingAvailability.TICKETS) {
    return ticketsPath
  }

  if (
    payload.bookingAvailability.value.type ===
    BookingAvailability.SPOTS_AND_TICKETS
  ) {
    if (hasTicketsGroupIdsFilter) {
      return ticketsPath
    }

    return chooseProductPath
  }

  // FIXME: Probably we never get here :D
  if (payload.bookingPeriod === BookingPeriod.ALL_SEASON) {
    return hasTicketsGroupIdsFilter ? ticketsPath : chooseProductPath
  }

  return null
}
